// Imports
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components/macro';


// Styled components
const Wrapper = styled.ul`
	list-style: none;
	margin: 0;
	white-space: nowrap;
	
	> li {
		overflow-x: clip;
		text-overflow: ellipsis;
		
		svg {
			margin-right: 0.5rem;
		}
	}
`;

export interface ContactDetails {
	icon: IconDefinition;
	text: string;
	href: string;
}


// Define the accepted props
interface Props {
	contactDetails: ContactDetails[];
}


// Function component
const ContactInfo: React.FC<Props> = ({ contactDetails }) => (
	<Wrapper>
		{contactDetails.map(({ icon, href, text }, i) => (
			<li key={i}>
				<FontAwesomeIcon icon={icon} />
				
				<a href={href} target='_blank' rel='noopener noreferrer'>
					{text}
				</a>
			</li>
		))}
	</Wrapper>
);

export default ContactInfo;
